"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../Label"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar.style"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let ProgressBar = (_dec = (0, _reactJss.default)(_ProgressBar.default), _dec(_class = class ProgressBar extends _react.PureComponent {
  calcCirclePercent(r, value) {
    if (!value) return {};
    const cLen = Math.PI * (r * 2);
    const per = value / 100 * cLen;
    return {
      strokeDasharray: `${per}px, 200px`,
      strokeDashoffset: '0px'
    };
  }

  correctValue(value) {
    // correct value min 0, max 100;
    const min = 0;
    const max = 100;
    if (value < min) value = min;
    if (value > max) value = max; // check for a number

    if (!Number(value)) value = false;
    return value;
  }

  renderCircle(classes, value) {
    const cls = (0, _clsx.default)(classes.circleBar, {
      circleAnimation: !value
    });
    const r = 20;
    const styleProgress = this.calcCirclePercent(r, value);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.circleWrap
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: cls,
      viewBox: "0 0 50 50"
    }, value ? /*#__PURE__*/_react.default.createElement("circle", {
      cx: "25",
      cy: "25",
      r: r,
      fill: "none",
      className: classes.circleBackground
    }) : null, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "25",
      cy: "25",
      r: r,
      fill: "none",
      style: styleProgress
    })), value ? /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: classes.circleLabel,
      value: `${value}%`
    }) : null);
  }

  renderLine(classes, value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.lineWrap
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.progressLineBackground
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.progressLine, {
        animation: !value
      }),
      style: {
        width: `${value}%`
      }
    })), value ? /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: classes.lineLabel,
      value: `${value}%`
    }) : null);
  }

  render() {
    const {
      id,
      classes,
      className,
      size,
      type,
      value,
      visibility
    } = this.props;
    const corValue = this.correctValue(value);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.progressBar, classes[size], classes[type], {
        hidden: visibility === 'hidden'
      })
    }, type === 'circle' ? this.renderCircle(classes, corValue, size) : this.renderLine(classes, corValue));
  }

}) || _class);
ProgressBar.defaultProps = {
  visibility: 'visible',
  type: 'circle',
  size: 'medium'
};
var _default = ProgressBar;
exports.default = _default;